import * as React from "react";
import {cx} from "emotion";

import "./editing.scss";

import {bindInput}      from "@Common/react/bind-input";
import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {Form2}          from "@Common/react/cs-form-2/form2";
import {required}       from "@Common/react/cs-form-2/validators/required";
import {UseState}       from "@Common/react/use-state";
import {chain}          from "@Common/utils/fs";

export const Editing = ({agentId, next: rootNext}) => cs(
    ["active", (_, next) => UseState({next})],
    ({active}) => rootNext({
        activate: () => active.onChange(true),
        deactivate: () => active.onChange(false),
        active: active.value,
        render: ({saved}) => cs(
            ["data", (_, next) => UseState({
                getInitValue: () => ({
                    idMailer: "" + (saved.value?.idMailer ?? ""),
                    confirm: null,
                }),
                next,
            })],
            ["form", ({data}, next) => Form2({
                data,
                fields: [
                    {
                        path: ["idMailer"],
                        validators: [required],
                    },
                    {
                        path: ["confirm"],
                        validators: [
                            required,
                            {
                                name: "confirm",
                                validate: (value, {data}) => data.idMailer === value,
                            }
                        ],
                    },
                ],
                next,
            })],


            ["apiError", (_, next) => UseState({next})],

            ({form, data, apiError}) => (
                <div className="editing-0ag">
                    <div className="title" xd-qa-type="label" xd-qa-name="Editing Mailer ID">
                        Editing Mailer ID
                    </div>

                    <div className="form">
                        {(() => {
                            const renderField = ({label, path}) => {
                                const field = form.field(path);
                                const error = field.error;

                                return (
                                    <div className="form-group">
                                        <div className="control-label" xd-qa-type="label" xd-qa-name={label}>
                                            {label}<span className="required" xd-qa-type="label" xd-qa-name={label + " Required"}>*</span>
                                        </div>

                                        <input {...{
                                            ...bindInput({
                                                value: field.state.value,
                                                onChange: (v) => {
                                                    field.state.onChange(v);
                                                    apiError.onChange(null);
                                                },
                                            }),
                                            className: cx({hasError: error}),
                                        }}
                                            xd-qa-type="textbox"
                                            xd-qa-name={label + " Input"}
                                        />

                                        {error && (
                                            <div className="error" xd-qa-type="text" xd-qa-name="Error">
                                                {chain(
                                                    error.failedValidator.name,
                                                    (name) => name === "required" ? (
                                                        "Required"
                                                    ) : name === "confirm" ? (
                                                        "Confirm field doesn't match"
                                                    ) : (
                                                        "Unknown error"
                                                    )
                                                )}
                                            </div>
                                        )}
                                    </div>
                                );
                            };

                            return <>
                                {renderField({
                                    label: "Mailer ID",
                                    path: ["idMailer"],
                                })}
                                {renderField({
                                    label: "Confirm Mailer ID",
                                    path: ["confirm"],
                                })}
                            </>;
                        })()}
                    </div>

                    {apiError.value && (
                        <div className="error" xd-qa-type="text" xd-qa-name="API Error">
                            {apiError.value}
                        </div>
                    )}

                    <div className="actions">
                        {cs(
                            consumeContext("apis"),
                            ({apis}) => (
                                <button {...{
                                    className: cx("save", {disabled: !form.valid}),
                                    disabled: form.submitting,
                                    onClick: async () => form.submit({
                                        onSubmit: async () => {
                                            apiError.onChange(null);
                                            try {
                                                await apis.next.imb.saveMailerId({
                                                    idMailer: data.value.idMailer,
                                                    idPrimary: saved.value?.idPrimary,
                                                    idEntity: agentId,
                                                });
                                                if (saved.value) {
                                                    saved.onChange({
                                                        idMailer: data.value.idMailer,
                                                        idPrimary: saved.value.idPrimary,
                                                    });
                                                } else {
                                                    saved.onChange(await apis.next.imb.getMailerId());
                                                }
                                                active.onChange(false);
                                            } catch (e) {
                                                apiError.onChange(e);
                                            }
                                        },
                                    }),
                                }}
                                    xd-qa-type="button"
                                    xd-qa-name="SAVE"
                                >
                                    {form.submitting ? (
                                        <>
                                            SAVING... <i className="fa fa-spinner fa-pulse" xd-qa-type="icon" xd-qa-name="Spinner"/>
                                        </>
                                    ) : (
                                        "SAVE"
                                    )}

                                </button>
                            )
                        )}

                        <button {...{
                            className: "cancel",
                            onClick: () => active.onChange(false),
                        }}
                            xd-qa-type="button"
                            xd-qa-name="CANCEL"
                        >
                            CANCEL
                        </button>

                    </div>
                </div>
            ),
        ),
    }),
);
